// Route guard for menu sections: a person who types the URL of a section their role cannot open
// is sent to their own landing page. Display only; the API refuses the data either way.
import { redirect } from '@tanstack/react-router';
import type { Permission } from '@cis/shared';
import type { Me } from '@cis/api-client';
import { can, canSee, landingPath, navItemFor, type SectionPath } from './nav.ts';

export interface AuthedContext {
  readonly context: { readonly me: Me };
}

export function guardSection(path: SectionPath): (args: AuthedContext) => void {
  const item = navItemFor(path);
  return ({ context }) => {
    if (canSee(context.me, item)) return;
    // landingPath only returns sections canSee allows, so this cannot redirect back here.
    throw redirect({ to: landingPath(context.me), replace: true });
  };
}

/**
 * Guard for a page inside a section (an admin page, a task page): the person needs `permission`
 * as can() reads it. Anyone else goes to their own landing page.
 */
export function guardPermission(permission: Permission): (args: AuthedContext) => void {
  return ({ context }) => {
    if (can(context.me, permission)) return;
    throw redirect({ to: landingPath(context.me), replace: true });
  };
}
